<section class="top-banner mb-4">
    <div class="top-banner-img" style="">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1 style="padding: 30px 0px 0px 0px !important;">Mes Langues </h1>
                    <p class="text-white link-nav"><a [routerLink]="['/accueil', 'candidat']"
                            style="color: #ff5a00 !important">Accueil</a> <span class="lnr lnr-arrow-right"></span>
                        <span> langues</span>
                    </p>

                </div>
            </div>
        </div>
    </div>
</section>

<section class="service-area section-gap" id="service">
    <div class="container mb-5">
        <!-- Taux de remplissage (progress bar) -->
        <!-- <div class="col-md-12 mb-3">
            <div class="label-progress">Taux de remplissage de vos informations</div>
            <div class="progress">
                <div [ngClass]="{'progress-bar bg-danger text-white': totalFillingRate < 50, 'progress-bar bg-warning text-dark' : totalFillingRate < 100, 'progress-bar bg-success text-center text-white' : totalFillingRate === 100 }"
                    role="progressbar" [ngStyle]="{'width': totalFillingRate + '%', 'text-align': 'center'}"
                    aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">{{ totalFillingRate }}%</div>
            </div>
        </div> -->
        <div class="row mb-4">
            <div class="col-md-12 ">
                <div class="card"
                    style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);border-radius: 15px;">
                    <div class="card-body">
                        <p>Profil complèté à {{ totalFillingRate }}%</p>
                        <div class="progress">
                            <div [ngClass]="{'progress-bar bg-danger text-white': totalFillingRate < 50, 'progress-bar bg-warning text-dark' : totalFillingRate < 100, 'progress-bar bg-success text-center text-white' : totalFillingRate === 100 }"
                                role="progressbar" [ngStyle]="{'width': totalFillingRate + '%', 'text-align': 'center'}"
                                aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">{{ totalFillingRate }}%</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <section class="row justify-content-center">
            <div class="col-md-4 mb-3" *ngIf="showBtnToGoApplyJob">
                <a routerLink="/postuler/{{ jobIDToApply }}" class="btn btn-danger" style="color: white;">Retour vers
                    l'offre</a>
            </div>
        </section>
        <section class="row">
            <div class="col-md-10">
                <div class="card  mb-3 pr-5 pl-5"
                    style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
                    <div class="card-body" id="depot-cv">

                        <div class="row">
                            <div class=" col-md-6">
                                <fieldset class="form-area fieldset-panel">
                                    <legend class="legend-style" style="width: 75%;">Ajouter une langue </legend>
                                    <form [formGroup]="languagesForm" (ngSubmit)="onSubmitLanguageForm()">
                                        <div class="row">
                                            <div class="form-group col-md-6">
                                                <label for="language">Langues <span class="star-style">**</span></label>
                                                <select class="form-control" id="language"
                                                    formControlName="language_id">
                                                    <option value="">Selectionner...</option>
                                                    <option [value]="language.getId()"
                                                        *ngFor="let language of languageList">{{
                                                        language.getLibelle() }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label for="levelLanguage">Niveau de maitrise <span
                                                        class="star-style">**</span></label>
                                                <select class="form-control" id="levelLanguage" formControlName="level">
                                                    <option value="">Selectionner...</option>
                                                    <option value="Débutant">Débutant</option>
                                                    <option value="Intermédiaire">Intermédiaire</option>
                                                    <option value="Excellente maitrise">Excellente maitrise</option>
                                                </select>
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label for="certificat">Certificat<span
                                                        style="font-size: 10px; font-weight: 700;">(pdf,
                                                        < 1Mo)</span>
                                                </label>
                                                <span class="form-control h-40px btn btn-success"
                                                    (click)="chooseCertificat()">Joindre
                                                    fichier</span><span *ngIf="certificatFile != null"
                                                    style="font-size: 10px; font-weight: 700; color: green">
                                                    Super! Fichier
                                                    joint</span>
                                            </div>
                                            <div class="col-md-6">
                                                <button type="submit" style="margin-top: 35px;"
                                                    class="primary-btn text-white">Ajouter</button>
                                                <p class="text-danger" style="padding-top: 15px; margin-left: 15px;"
                                                    *ngIf="languageIsLoading">
                                                    Veuillez
                                                    patienter...
                                                </p>
                                            </div>
                                        </div>


                                    </form>
                                </fieldset>
                            </div>
                            <div class=" col-md-6">
                                <!-- Liste des ajouts -->
                                <div class="form-group mt-5" style="width: 100%; overflow: auto;">
                                    <table class="table table-bordered">
                                        <tr>
                                            <th>Langue</th>
                                            <th>Niveau de maitrise</th>
                                            <th>Action</th>
                                        </tr>
                                        <tr *ngFor="let candidateLanguage of candidateLanguageList">
                                            <td>{{ candidateLanguage.getLanguages()['libelle'] }}</td>
                                            <td>{{ candidateLanguage.getLevel() }}</td>
                                            <td>

                                                <span class="btn btn-info a-btn-slide-text mr-1">
                                                    <span class="glyphicon glyphicon-edit" aria-hidden="true">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                            fill="currentColor" class="bi bi-pen" viewBox="0 0 16 16">
                                                            <path
                                                                d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z" />
                                                        </svg>
                                                    </span>
                                                </span>
                                                <a *ngIf="candidateLanguage.getFilePath() != ''"
                                                    [href]="candidateLanguage.getFilePath()" target="_blank"
                                                    class="btn btn-primary a-btn-slide-text mr-1">
                                                    {{candidateLanguage.getFilePath()}}
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                        fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                                                        <path
                                                            d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                        <path
                                                            d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                                    </svg></a>
                                                <span class="btn btn-danger a-btn-slide-text"
                                                    (click)="removeLanguage(candidateLanguage.getId())">
                                                    <span class="glyphicon glyphicon-remove" aria-hidden="true"><svg
                                                            xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                            fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                            <path
                                                                d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                                            <path fill-rule="evenodd"
                                                                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                                        </svg></span>
                                                </span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center mt-5">
                            <button class="btn btn-outline-warning col-md-2 mr-2" routerLink="/candidat-software">Retour
                            </button>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-md-2"></div>

        </section>




    </div>
</section>